import React, { useState, createRef, useEffect, useRef } from "react";

import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import HeaderBar from "../../components/header/headerBar";
import MainButton from "../../components/button/mainButton";
import FromQuotation from "../../assets/images/quotations.png";
import Print from "./template/printHistory";
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import axios from "axios";
const baseURL: String | any = process.env.REACT_APP_BASE_URL;
const CashierInvoiceHistory = () => {
  const { id, payment } = useParams<{
    id: string;
    payment: string;
  }>();
  const [data, setData] = useState<any>({});
  const refPrint: any = useRef("refPrint");
  const [dataPayment, setDataPayment] = useState<any>({});
  const handlePrint = useReactToPrint({
    content: () => refPrint.current,
    pageStyle: "@page { size: A4 portrait; }"
  });

  const refPdf = createRef<HTMLIFrameElement>()
  const onPrint = () => {
    const { current } = refPdf;
    console.log(current?.contentWindow)
    current?.contentWindow?.focus();
    current?.contentWindow?.print();
  }
  useEffect(() => {
    getDetail()
  }, []);
  const getDetail = () => {
    axios.get(`/so/get-so?soId=${id}`).then((res) => {
      setData(res?.data)
      console.log(res)
    })
    axios.get(`/payments/record/${payment}`).then((res: any) => {
      setDataPayment(res?.data)
      console.log(res)
    })
  }
  return (
    <div>
      <HeaderBar title="CASHIER/Payment History " btnBack={true} />
      <div style={{ marginTop: "20px" }}>
        <div style={{ padding: "0px 80px" }}>
          <div className="row">
            <div className="col-6"><h6>ใบกำกับภาษี/Tax Invoice</h6></div>
            <div className="col-6" style={{
              "display": "flex",
              "justifyContent": "flex-end"
            }}>
              <MainButton title="Print" onClick={() => handlePrint()}>
                < Icon path={mdiPrinter} size="20" color="#FFFFFF" />
              </MainButton>
            </div>
          </div>
          <div className="mt-20">
            <Print data={data} payment={dataPayment} refPrint={refPrint} />
          </div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              title="ย้อนกลับหน้าแรก/Go Back"
              to={"/quotation"}
            />
          </div>
        </div>
      </div >
    </div >
  );
};
export default CashierInvoiceHistory;
